// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__6gcYI","box":"style_box__lmbJZ","active":"style_active__jByPW","title":"style_title__gqpxg","item":"style_item__Q9Cub"};